var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePill',{class:`variant-${_vm.variant}`,attrs:{"text":_vm.text,"hoverable":_vm.hoverable,"selected":_vm.selected,"size":_vm.size,"theme":_vm.theme}})
}
var staticRenderFns = []

export { render, staticRenderFns }